import { render } from "./AutoLogin.vue?vue&type=template&id=47f4e0bd&scoped=true"
import script from "./AutoLogin.vue?vue&type=script&lang=js"
export * from "./AutoLogin.vue?vue&type=script&lang=js"

import "./AutoLogin.vue?vue&type=style&index=0&id=47f4e0bd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f4e0bd"]])

export default __exports__